import { callWithRetry } from "../../services/callWithRetry";
import { API_PDC_URL_V2, API_PDC_URL_V1 } from "../../../config";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const fulfilmentsConstants = {
  GET_FULFILMENTS_START: "GET_FULFILMENTS_START",
  GET_FULFILMENTS_SUCCESS: "GET_FULFILMENTS_SUCCESS",
  GET_FULFILMENTS_ERROR: "GET_FULFILMENTS_ERROR",

  COMPLETE_FULFILMENT_START: "COMPLETE_FULFILMENT_START",
  COMPLETE_FULFILMENT_SUCCESS: "COMPLETE_FULFILMENT_SUCCESS",
  COMPLETE_FULFILMENT_ERROR: "COMPLETE_FULFILMENT_ERROR",

  CLEAR_FULFILMENTS: "CLEAR_FULFILMENTS"
};

/**
 * Restituisce la lista di fascicoli secondo i filtri impostati
 *
 * @param {object} auth
 * @param {string} managerId
 * @param {string} itemId
 */
export function getFulfilments({ auth, managerId, itemId = "", fromDate = "", toDate = "" }) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: fulfilmentsConstants.GET_FULFILMENTS_START
      });
      let request = {
        method: "GET",
        url: `${API_PDC_URL_V2}/fulfilments?ownerId=${managerId}&itemIds=${itemId}&fromDate=${fromDate}&toDate=${toDate}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: fulfilmentsConstants.GET_FULFILMENTS_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: fulfilmentsConstants.GET_FULFILMENTS_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}

export function completeFulfilment(
  auth, managerId, itemId, fulfilmentId
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      const additionalHeaders = {
        "x-manager-id": managerId,
        "x-item-id": itemId
      };
      dispatch({
        type: fulfilmentsConstants.COMPLETE_FULFILMENT_START
      });
      let request = {
        method: "POST",
        url: `${API_PDC_URL_V1}/backoffice/customer/fulfilment/link/complete`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: {
          id: fulfilmentId
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: fulfilmentsConstants.COMPLETE_FULFILMENT_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: fulfilmentsConstants.COMPLETE_FULFILMENT_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}

export function clearFulfilments() {
  return (dispatch) => {
    dispatch({
      type: fulfilmentsConstants.CLEAR_FULFILMENTS
    });
  };
}
